var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9864_120200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 13,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9864_120200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6562 33.0013V29.668H32.3229V33.0013H15.6562ZM18.9896 26.3346H20.1562L26.6562 19.8555L25.4687 18.668L18.9896 25.168V26.3346ZM17.3229 28.0013V24.4596L26.6562 15.1471C26.809 14.9944 26.9861 14.8763 27.1875 14.793C27.3889 14.7096 27.6007 14.668 27.8229 14.668C28.0451 14.668 28.2604 14.7096 28.4687 14.793C28.6771 14.8763 28.8646 15.0013 29.0312 15.168L30.1771 16.3346C30.3437 16.4874 30.4653 16.668 30.5417 16.8763C30.6181 17.0846 30.6562 17.2999 30.6562 17.5221C30.6562 17.7305 30.6181 17.9353 30.5417 18.1367C30.4653 18.3381 30.3437 18.5221 30.1771 18.6888L20.8646 28.0013H17.3229Z",
    fill: "#1A3D6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.2be69e7465aa4c079bba3677738bcc8b.svg";
export { ForwardRef as ReactComponent };